export default "__VITE_ASSET__Bwlt0eG3__"